// extracted by mini-css-extract-plugin
export default {"asset-section-asset":"gaw1w1ju3bmDcVFEF37O","assetSectionAsset":"gaw1w1ju3bmDcVFEF37O"};